import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import {
  useIsReportCompleted,
  useIsReportHandlebars,
  useIsReviewPage,
} from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION, RECOMMENDATIONS_PAGE_LOCATION } from "@components/ReportField/consts";
import { useAdminData } from "@providers/AdminDataProvider";
import { useReport } from "@providers/ReportProvider";

// Whether the "Remove Field" item shows. Reproduces the legacy FieldBlockCardWrapper
// menu gating per surface (surface derived from reportType + viewMode):
//   assessment  (InitialAssessment)          -> handlebars export off the review page
//   evaluation  (DiagnosisEvaluation + step) -> base template, appendix, or non-Catalight recommendations
//   clinical    (Reassessment | DE + single) -> handlebars, appendix (single-page), or non-Catalight recommendations
export const useCanDeleteField = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const { isCatalightUser } = useAdminData();
  const isReviewPage = useIsReviewPage();
  const isHandlebars = useIsReportHandlebars();
  const isCompleted = useIsReportCompleted();

  const reportType = report.reportType;
  const onAppendix = section.pageLocation === APPENDIX_PAGE_LOCATION;
  const onRecommendations = section.pageLocation === RECOMMENDATIONS_PAGE_LOCATION;

  if (isCompleted) return false;

  if (reportType === ApiReportReportTypeChoices.InitialAssessment) {
    return isHandlebars && !isReviewPage;
  }
  if (reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "step") {
    const isBaseTemplate = report.reportTemplate?.isBaseTemplate ?? false;
    return isBaseTemplate || onAppendix || (onRecommendations && !isCatalightUser);
  }

  if (isHandlebars) return true;
  const appendixSupported = reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "single";
  if (appendixSupported && onAppendix) return true;
  if (onRecommendations) return !isCatalightUser && !isReviewPage;
  return false;
};
